import { render, staticRenderFns } from "./AISummary.vue?vue&type=template&id=83d243b8&scoped=true&"
import script from "./AISummary.vue?vue&type=script&lang=js&"
export * from "./AISummary.vue?vue&type=script&lang=js&"
import style0 from "./AISummary.vue?vue&type=style&index=0&id=83d243b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d243b8",
  null
  
)

export default component.exports